import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=74e54e64&scoped=true&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e54e64",
  null
  
)

export default component.exports